/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { FC, useState } from 'react';

type Props = {
  collapsed: boolean;
  header: string;
  level: number;
  children: React.ReactNode;
};

const AUCollapsibleComponent: FC<Props> = ({
  collapsed,
  header,
  level,
  children,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(collapsed);

  let className = 'csc-frame au_collapsible';
  if (collapsed) {
    className += ' au_collapsed';
  }

  return (
    <div className={className}>
      {
        level > 0 && (
          <div
            className="csc-header"
            onClick={() => {
              setIsCollapsed(!isCollapsed);
            }}
            role="button"
            tabIndex={0}
          >
            {(() => {
              switch (level) {
                case 1:
                  return (
                    <h1>
                      {header}
                    </h1>
                  );
                case 2:
                  return (
                    <h2>
                      {header}
                    </h2>
                  );
                case 3:
                  return (
                    <h3>
                      {header}
                    </h3>
                  );
                case 4:
                  return (
                    <h4>
                      {header}
                    </h4>
                  );
                case 5:
                  return (
                    <h5>
                      {header}
                    </h5>
                  );
                default:
                  return (
                    <h6>
                      {header}
                    </h6>
                  );
              }
            })()}
          </div>
        )
      }
      {children}
    </div>
  );
};

AUCollapsibleComponent.displayName = 'AUCollapsibleComponent';
export default AUCollapsibleComponent;
